import { ReactElement, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// project imports
import usePermissions from 'hooks/usePermissions';
import { hasAnyMaintenanceAccess } from 'utils/maintenanceAccess';

// ==============================|| MAINTENANCE GUARD ||============================== //

/**
 * Route guard for Maintenance (master data) pages. Redirects away unless the user holds at
 * least one of the relevant permissions — either any Maintenance permission (the default),
 * or the specific `requiredPermissions` passed in for a narrower sub-route (eg. an import route).
 */
export default function MaintenanceGuard({
  children,
  requiredPermissions
}: {
  children: ReactElement | null;
  requiredPermissions?: string[];
}) {
  const { hasPermission, loading } = usePermissions();
  const navigate = useNavigate();

  const authorized = requiredPermissions ? requiredPermissions.some((code) => hasPermission(code)) : hasAnyMaintenanceAccess(hasPermission);

  useEffect(() => {
    if (loading) return;
    if (!authorized) navigate('/pages/access-denied', { replace: true });
  }, [loading, authorized, navigate]);

  if (loading || !authorized) return null;

  return children;
}
